import { useEffect, useState } from 'react';

// Phones (800 px wide or less) get their own layout: a tab bar, the chat as the main view of a thread with the cards
// in a sheet, lists instead of tables. Wider screens render exactly as before, so this is read in code, not only CSS.

export const PHONE_MAX = 800;
export const isPhone = () => typeof window !== 'undefined' && window.innerWidth <= PHONE_MAX;

/** True on a phone; follows rotation and resizing. */
export function usePhone() {
  const [phone, set] = useState(isPhone);
  useEffect(() => {
    const f = () => set(isPhone());
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);
  return phone;
}

/** A thread page on a phone: the chat is the screen, its cards sit in a sheet at the bottom. */
export const PHONE_THREAD = /^\/(campaigns\/(new|[0-9a-f-]{36})|chat\/[0-9a-f-]{36}|chat)$/;

/** Opened straight from a link (an alert, an email) rather than from inside the app: nothing to go back to. */
export const openedDirectly = () => {
  try { return !(window.history.state as { idx?: number } | null)?.idx; } catch { return true; }
};

/** "5 min ago", "3 h ago", "yesterday", "Oct 3". */
export function ago(iso: string | null | undefined, now = Date.now()) {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const min = Math.round((now - t) / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} h ago`;
  if (h < 48) return 'yesterday';
  const d = new Date(t);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', ...(d.getFullYear() !== new Date(now).getFullYear() ? { year: 'numeric' } : {}) });
}
